import React from 'react';
import { View, Text, TouchableOpacity, Image, Dimensions } from 'react-native';
import styles from '../screens/EventsScreen.styles';

interface EventsHeaderProps {
  title?: string;
  onBack?: () => void;
  showSearch?: boolean;
  dateRange?: string;
  rightContent?: React.ReactNode;
}

export const EventsHeader: React.FC<EventsHeaderProps> = ({ 
  title = 'Events', 
  onBack,
  showSearch = false,
  dateRange,
  rightContent,
}) => {
  const { width } = Dimensions.get('window');
  const isDesktop = width >= 1024;
  const isTablet = width >= 768 && width < 1024;

  return (
    <View style={[styles.headerContainer, (isDesktop || isTablet) && styles.headerContainerDesktop]}>
      <View style={[styles.header, isDesktop && styles.headerDesktop]}>
        <TouchableOpacity onPress={onBack} style={styles.backButton}>
          <Text style={[styles.backIcon, (isDesktop || isTablet) && styles.backIconDesktop]}>‹</Text>
        </TouchableOpacity>
        {isDesktop ? (
          <>
            <View style={styles.headerLeft}>
              <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                <Text style={[styles.headerTitle, styles.headerTitleDesktop]}>{title}</Text>
                {rightContent}
              </View>
              {dateRange && (
                <Text style={[styles.dateRangeTextInline, styles.dateRangeTextInlineDesktop]}>{dateRange}</Text>
              )}
            </View>
            {showSearch && (
              <TouchableOpacity style={styles.searchButton}>
                <Text style={[styles.searchIcon, styles.searchIconDesktop]}>🔍</Text>
              </TouchableOpacity>
            )}
            {!showSearch && <View style={styles.headerSpacer} />}
          </>
        ) : (
          <>
            <View style={styles.headerContent}>
              <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                <Text style={[styles.headerTitle, isTablet && styles.headerTitleDesktop]}>{title}</Text>
                {rightContent}
              </View>
            </View>
            <View style={styles.headerSpacer} />
          </>
        )}
      </View>
      {!isDesktop && dateRange && (
        <View style={styles.dateRangeContainer}>
          <Text style={styles.dateRangeText}>{dateRange}</Text>
        </View>
      )}
    </View>
  );
};


